import { CalendarData } from '@card/commonlib';
import { DashboardActionType, DashboardAction } from './actions';
import { Loadable, LoadableStatus } from '@card/types';

export interface DashboardState {
  soldAmounts: Loadable<CalendarData>;
  collectedAmounts: Loadable<CalendarData>;
  collectToday: Loadable<number>;
  collectTomorrow: Loadable<number>;
  monthlyChargebacks: Loadable<number>;
}

const initialState: DashboardState = {
  soldAmounts: { status: LoadableStatus.Fetching },
  collectedAmounts: { status: LoadableStatus.Fetching },
  collectToday: { status: LoadableStatus.Fetching },
  collectTomorrow: { status: LoadableStatus.Fetching },
  monthlyChargebacks: { status: LoadableStatus.Fetching }
};

export function dashboardReducer(state = initialState, action: DashboardAction): DashboardState {
  switch (action.type) {
    case DashboardActionType.FetchSoldAmountsStarted:
      return {
        ...state,
        soldAmounts: { status: LoadableStatus.Fetching }
      };
    case DashboardActionType.FetchSoldAmountsSuccess:
      return { ...state, soldAmounts: { status: LoadableStatus.Fetched, data: action.payload } };
    case DashboardActionType.FetchSoldAmountsError:
      return { ...state, soldAmounts: { status: LoadableStatus.Error, error: action.payload } };
    case DashboardActionType.FetchCollectedAmountsStarted:
      return {
        ...state,
        collectedAmounts: { status: LoadableStatus.Fetching }
      };
    case DashboardActionType.FetchCollectedAmountsSuccess:
      return {
        ...state,
        collectedAmounts: { status: LoadableStatus.Fetched, data: action.payload }
      };
    case DashboardActionType.FetchCollectedAmountsError:
      return {
        ...state,
        collectedAmounts: { status: LoadableStatus.Error, error: action.payload }
      };
    case DashboardActionType.FetchCollectTodayStarted:
      return { ...state, collectToday: { status: LoadableStatus.Fetching } };
    case DashboardActionType.FetchCollectTodaySuccess:
      return { ...state, collectToday: { status: LoadableStatus.Fetched, data: action.payload } };
    case DashboardActionType.FetchCollectTodayError:
      return { ...state, collectToday: { status: LoadableStatus.Error, error: action.payload } };
    case DashboardActionType.FetchCollectTomorrowStarted:
      return {
        ...state,
        collectTomorrow: { status: LoadableStatus.Fetching }
      };
    case DashboardActionType.FetchCollectTomorrowSuccess:
      return {
        ...state,
        collectTomorrow: { status: LoadableStatus.Fetched, data: action.payload }
      };
    case DashboardActionType.FetchMonthlyChargebacksStarted:
      return {
        ...state,
        monthlyChargebacks: { status: LoadableStatus.Fetching }
      };
    case DashboardActionType.FetchMonthlyChargebacksSuccess:
      return {
        ...state,
        monthlyChargebacks: { status: LoadableStatus.Fetched, data: action.payload }
      };
    case DashboardActionType.FetchMonthlyChargebacksError:
      return {
        ...state,
        monthlyChargebacks: { status: LoadableStatus.Error, error: action.payload }
      };
    default:
      return state;
  }
}
